<template>
  <div class="cadre-page">
    <!-- Hero -->
    <section class="cadre-hero">
      <div class="cadre-hero__bg"></div>
      <div class="cadre-hero__grid-lines"></div>
      <div class="cadre-hero__overlay"></div>
      <div class="container cadre-hero__wrap">
        <div class="cadre-hero__main">
          <div class="cadre-hero__content">
            <div class="cadre-hero__badge">{{ pageMeta.badge }}</div>
            <h1 class="cadre-hero__title">{{ pageMeta.title }}</h1>
            <p class="cadre-hero__desc">{{ pageMeta.description }}</p>
            <div class="cadre-hero__actions">
              <router-link to="/cadre-management#contact" class="btn btn-primary btn-hero">预约演示 →</router-link>
              <a href="#architecture" class="btn btn-outline btn-hero">了解产品功能</a>
            </div>
          </div>
          <HeroVisual class="cadre-hero__visual" />
        </div>
        <div class="cadre-hero__stats">
          <div class="cadre-hero__stats-grid">
            <div
              v-for="(item, index) in pageMeta.stats"
              :key="item.label"
              class="cadre-hero__stat"
            >
              <div class="cadre-hero__stat-icon">{{ item.icon }}</div>
              <div
                :class="['cadre-hero__stat-value', { 'cadre-hero__stat-value--compact': item.compact }]"
              >{{ item.value }}</div>
              <div class="cadre-hero__stat-label">{{ item.label }}</div>
              <span
                v-if="index < pageMeta.stats.length - 1"
                class="cadre-hero__stat-divider"
                aria-hidden="true"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 方案架构 -->
    <section id="architecture" class="section cadre-arch">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">方案架构</h2>
          <p class="section-desc">{{ architecture.desc }}</p>
        </div>
        <CadreArchDiagram :architecture="architecture" />
      </div>
    </section>

    <!-- 核心能力 -->
    <section id="capabilities" class="section cadre-cap">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">核心能力</h2>
          <p class="section-desc">九大核心能力覆盖干部管理全生命周期，以数据驱动组织人事决策科学化。</p>
        </div>

        <div class="cadre-cap__layout">
          <div class="cadre-cap__tabs">
            <button
              v-for="(cap, index) in capabilities"
              :key="cap.id"
              :class="['cadre-cap__tab', { 'cadre-cap__tab--active': activeCap === index }]"
              @click="activeCap = index"
            >{{ cap.title }}</button>
          </div>

          <div class="cadre-cap__detail">
            <div class="cadre-cap__info">
              <h3>{{ currentCap.title }}</h3>
              <p class="cadre-cap__summary">{{ currentCap.summary }}</p>
              <ul class="cadre-cap__features">
                <li v-for="(feat, i) in currentCap.features" :key="i">
                  <span class="cadre-cap__num">{{ i + 1 }}</span>
                  <div>
                    <strong>{{ feat.title }}：</strong>{{ feat.desc }}
                  </div>
                </li>
              </ul>
              <div class="cadre-cap__tags">
                <span v-for="tag in currentCap.tags" :key="tag">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 为什么选择我们 -->
    <section class="section cadre-why">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">为什么选择我们</h2>
        </div>
        <div class="cadre-why__stats">
          <div v-for="s in whyUs.stats" :key="s.label" class="cadre-why__stat">
            <strong>{{ s.value }}</strong>
            <span>{{ s.label }}</span>
          </div>
        </div>
        <div class="cadre-why__grid">
          <div v-for="item in whyUs.items" :key="item.title" class="cadre-why__card">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 业务落地场景 -->
    <section class="section cadre-scenario">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">业务落地场景</h2>
          <p class="section-desc">覆盖干部"选、育、管、用"全生命周期，为各级组织部门提供端到端的数字化解决方案。</p>
        </div>
        <div class="cadre-scenario__grid">
          <div v-for="item in scenarios" :key="item.title" class="cadre-scenario__card">
            <span class="cadre-scenario__label">{{ item.label }}</span>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
            <div class="cadre-scenario__tags">
              <span v-for="tag in item.tags" :key="tag">{{ tag }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 典型客户 -->
    <!-- <section class="section cadre-clients">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">典型客户</h2>
          <p class="section-desc">已为全国500余家政企客户提供干部管理数字化解决方案。</p>
        </div>
        <p class="cadre-clients__note">部分用户展示，排名不分先后</p>
        <div class="cadre-clients__grid">
          <div v-for="c in cadreClients" :key="c" class="cadre-clients__item">{{ c }}</div>
        </div>
      </div>
    </section> -->

    <!-- 行业洞察 -->
    <!-- <section id="news" class="section cadre-news">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">行业洞察</h2>
          <p class="section-desc">跟踪干部管理数字化最新政策解读、行业资讯与产品更新动态，紧跟组织工作前沿趋势。</p>
        </div>
        <div class="cadre-news__grid">
          <div class="cadre-news__col">
            <h3>行业资讯</h3>
            <a v-for="item in newsItems.industry" :key="item.title" href="#" class="cadre-news__item">
              <span class="cadre-news__date">{{ item.date }}</span>
              <span class="cadre-news__title">{{ item.title }}</span>
              <span class="cadre-news__arrow">查看 →</span>
            </a>
            <a href="#" class="cadre-news__more">查看更多</a>
          </div>
          <div class="cadre-news__col">
            <h3>新闻动态</h3>
            <a v-for="item in newsItems.updates" :key="item.title" href="#" class="cadre-news__item">
              <span class="cadre-news__date">{{ item.date }}</span>
              <span class="cadre-news__title">{{ item.title }}</span>
              <span class="cadre-news__arrow">查看 →</span>
            </a>
            <a href="#" class="cadre-news__more">查看更多</a>
          </div>
        </div>
      </div>
    </section> -->

    <ContactForm default-product="干部管理系统" />
  </div>
</template>

<script>
import {
  pageMeta,
  capabilities,
  whyUs,
  scenarios,
  architecture,
  cadreClients,
  newsItems
} from '../data/cadre-management'
import ContactForm from '../components/ContactForm.vue'
import HeroVisual from '../components/HeroVisual.vue'
import CadreArchDiagram from '../components/CadreArchDiagram.vue'

export default {
  name: 'CadreManagement',
  components: { ContactForm, HeroVisual, CadreArchDiagram },
  data() {
    return {
      pageMeta,
      capabilities,
      whyUs,
      scenarios,
      architecture,
      cadreClients,
      newsItems,
      activeCap: 0
    }
  },
  computed: {
    currentCap() {
      return this.capabilities[this.activeCap]
    }
  }
}
</script>

<style scoped>
.cadre-hero {
  position: relative;
  padding: 88px 0 56px;
  overflow: hidden;
}

.cadre-hero__bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(125deg, #001233 0%, #002d6e 42%, #0052d9 100%);
}

.cadre-hero__grid-lines {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  mask-image: radial-gradient(ellipse 80% 70% at 50% 50%, black 20%, transparent 80%);
}

.cadre-hero__overlay {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 50% 60% at 85% 40%, rgba(0, 163, 255, 0.25) 0%, transparent 55%);
}

.cadre-hero__wrap {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.cadre-hero__main {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
  padding-top: 16px;
}

.cadre-hero__content {
  max-width: 560px;
  padding: 0 0 0 8px;
}

.cadre-hero__visual {
  justify-self: center;
}

.cadre-hero__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0.06));
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 24px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 22px;
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.cadre-hero__title {
  font-size: 42px;
  font-weight: 800;
  color: #fff;
  line-height: 1.2;
  margin-bottom: 18px;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 24px rgba(0, 40, 120, 0.35);
}

.cadre-hero__desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.8;
  margin-bottom: 32px;
}

.cadre-hero__actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.cadre-hero__stats {
  position: relative;
  z-index: 1;
  padding: 0 8px;
  margin-top: 8px;
}

.cadre-hero__stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.06) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  overflow: hidden;
  box-shadow:
    0 12px 40px rgba(0, 20, 80, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

.cadre-hero__stat {
  position: relative;
  padding: 28px 20px;
  text-align: center;
  transition: background 0.25s ease;
}

.cadre-hero__stat:hover {
  background: rgba(255, 255, 255, 0.08);
}

.cadre-hero__stat-divider {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 48px;
  background: linear-gradient(180deg, transparent, rgba(255, 255, 255, 0.2), transparent);
}

.cadre-hero__stat-icon {
  width: 44px;
  height: 44px;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  backdrop-filter: blur(8px);
}

.cadre-hero__stat-value {
  font-size: 34px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
  line-height: 1.15;
}

.cadre-hero__stat-value--compact {
  font-size: 24px;
  letter-spacing: 0;
}

.cadre-hero__stat-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.5;
}

/* 方案架构 */
.cadre-arch {
  background: linear-gradient(180deg, #f7f9fc 0%, #fff 100%);
}

.cadre-arch .section-title::after,
.cadre-cap .section-title::after,
.cadre-why .section-title::after,
.cadre-scenario .section-title::after {
  content: '';
  display: block;
  width: 40px;
  height: 4px;
  background: linear-gradient(90deg, #0052d9, #00a3ff);
  border-radius: 2px;
  margin: 12px auto 0;
}

.cadre-arch .section-header,
.cadre-cap .section-header,
.cadre-why .section-header,
.cadre-scenario .section-header {
  margin-bottom: 48px;
}

/* 核心能力 */
.cadre-cap { background: #fff; }

.cadre-cap__layout {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 32px;
  align-items: start;
}

.cadre-cap__tabs {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: sticky;
  top: 90px;
}

.cadre-cap__tab {
  text-align: left;
  padding: 12px 16px;
  border: none;
  background: #f7f9fc;
  border-radius: 8px;
  font-size: 14px;
  color: #444;
  cursor: pointer;
  transition: all 0.25s ease;
  line-height: 1.4;
  border: 1px solid transparent;
}

.cadre-cap__tab:hover {
  background: #eef4ff;
  color: #0052d9;
  border-color: #d6e4ff;
  transform: translateX(4px);
}

.cadre-cap__tab--active {
  background: linear-gradient(135deg, #0052d9, #0066ff);
  color: #fff;
  box-shadow: 0 4px 16px rgba(0, 82, 217, 0.35);
  transform: translateX(4px);
}

.cadre-cap__detail {
  background: linear-gradient(180deg, #f7f9fc 0%, #fff 100%);
  border-radius: 16px;
  padding: 36px 40px;
  border: 1px solid #eef1f6;
  box-shadow: 0 8px 32px rgba(0, 82, 217, 0.06);
}

.cadre-cap__info h3 {
  font-size: 24px;
  font-weight: 700;
  color: #0052d9;
  margin-bottom: 14px;
  padding-left: 14px;
  border-left: 4px solid #0052d9;
  line-height: 1.3;
}

.cadre-cap__summary {
  font-size: 15px;
  color: #555;
  line-height: 1.8;
  margin-bottom: 28px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e4eaf3;
}

.cadre-cap__features {
  list-style: none;
  margin-bottom: 28px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 32px;
}

.cadre-cap__features li {
  display: flex;
  gap: 12px;
  font-size: 14px;
  color: #555;
  line-height: 1.65;
  background: #fff;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid #eef1f6;
  transition: box-shadow 0.25s ease, border-color 0.25s ease;
}

.cadre-cap__features li:hover {
  border-color: #b8d4ff;
  box-shadow: 0 4px 16px rgba(0, 82, 217, 0.08);
}

.cadre-cap__num {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background: #0052d9;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  margin-top: 2px;
}

.cadre-cap__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cadre-cap__tags span {
  padding: 4px 12px;
  background: #fff;
  border: 1px solid #d6e4ff;
  color: #0052d9;
  border-radius: 4px;
  font-size: 12px;
}

/* 为什么选择我们 */
.cadre-why { background: #f7f9fc; }

.cadre-why__stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}

.cadre-why__stat {
  text-align: center;
  padding: 28px 24px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid #eef1f6;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.cadre-why__stat:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 82, 217, 0.1);
}

.cadre-why__stat strong {
  display: block;
  font-size: 32px;
  font-weight: 800;
  color: #0052d9;
  margin-bottom: 4px;
}

.cadre-why__stat span { font-size: 14px; color: #666; }

.cadre-why__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.cadre-why__card {
  background: #fff;
  padding: 28px;
  border-radius: 14px;
  border: 1px solid #eef1f6;
  border-top: 3px solid transparent;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-top-color 0.25s ease;
}

.cadre-why__card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 82, 217, 0.08);
  border-top-color: #0052d9;
}

.cadre-why__card h3 {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.cadre-why__card p {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
}

/* 业务场景 */
.cadre-scenario { background: #f7f9fc; }

.cadre-scenario__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.cadre-scenario__card {
  background: #fff;
  padding: 28px;
  border-radius: 14px;
  border: 1px solid #eef1f6;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.cadre-scenario__card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 36px rgba(0, 82, 217, 0.12);
}

.cadre-scenario__label {
  display: inline-block;
  font-size: 12px;
  color: #0052d9;
  background: #f0f5ff;
  padding: 4px 10px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.cadre-scenario__card h3 {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 10px;
  line-height: 1.4;
}

.cadre-scenario__card p {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 16px;
}

.cadre-scenario__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cadre-scenario__tags span {
  font-size: 12px;
  color: #888;
  padding: 2px 8px;
  background: #f7f9fc;
  border-radius: 4px;
}

/* 客户 */
.cadre-clients { background: #fff; }

.cadre-clients__note {
  text-align: center;
  font-size: 13px;
  color: #999;
  margin: -32px 0 32px;
}

.cadre-clients__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.cadre-clients__item {
  background: #f7f9fc;
  border: 1px solid #eef1f6;
  border-radius: 8px;
  padding: 18px 12px;
  text-align: center;
  font-size: 13px;
  color: #444;
  transition: all 0.25s;
}

.cadre-clients__item:hover {
  border-color: #0052d9;
  color: #0052d9;
}

/* 行业洞察 */
.cadre-news { background: #f7f9fc; }

.cadre-news__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

.cadre-news__col h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #0052d9;
}

.cadre-news__item {
  display: block;
  padding: 16px 0;
  border-bottom: 1px solid #eef1f6;
  transition: color 0.2s;
}

.cadre-news__item:hover { color: #0052d9; }

.cadre-news__date {
  display: block;
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
}

.cadre-news__title {
  display: block;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  margin-bottom: 4px;
}

.cadre-news__item:hover .cadre-news__title { color: #0052d9; }

.cadre-news__arrow {
  font-size: 13px;
  color: #0052d9;
}

.cadre-news__more {
  display: inline-block;
  margin-top: 16px;
  font-size: 14px;
  color: #0052d9;
  font-weight: 600;
}

@media (max-width: 960px) {
  .cadre-hero__main {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .cadre-hero__visual {
    order: -1;
  }

  .cadre-hero__title { font-size: 32px; }
  .cadre-hero__stats-grid { grid-template-columns: 1fr; }
  .cadre-hero__stat-divider { display: none; }
  .cadre-hero__stat + .cadre-hero__stat {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  .cadre-cap__layout { grid-template-columns: 1fr; }
  .cadre-cap__tabs {
    flex-direction: row;
    flex-wrap: wrap;
    position: static;
  }
  .cadre-cap__tab { flex: 1 1 auto; min-width: 140px; }
  .cadre-cap__detail { padding: 24px; }
  .cadre-cap__features { grid-template-columns: 1fr; }
  .cadre-why__stats { grid-template-columns: repeat(2, 1fr); }
  .cadre-why__grid { grid-template-columns: 1fr; }
  .cadre-scenario__grid { grid-template-columns: 1fr; }
  .cadre-clients__grid { grid-template-columns: repeat(2, 1fr); }
  .cadre-news__grid { grid-template-columns: 1fr; }
}
</style>
